import CGV from './CGV'

export default CGV
